import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Briefcase, Globe, Handshake } from "lucide-react";
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

const partnerData = [{
  type: "Strategy Partner",
  name: "BeenThereDoneThat",
  description: "BeenThereDoneThat helps enterprises develop cohesive brand architectures that leverage AI while maintaining consistent brand identity and voice across all marketing channels.",
  icon: Handshake
}, {
  type: "Training Partner",
  name: "SEQUENCR",
  description: "Sequencr specializes in helping marketing teams navigate the transition to AI-enabled workflows with comprehensive training and change management programs.",
  icon: Briefcase
}, {
  type: "Execution Partner",
  name: "ActivAsia",
  description: "Based in the Philippines, ActivAsia provides technical implementation services for enterprise clients across the APAC region, specializing in MarTech ecosystem integration.",
  icon: Globe
}, {
  type: "Execution Partner",
  name: "Curativity",
  description: "Curativity delivers specialized implementation services for content operations transformation, with deep expertise in workflow optimization and content governance.",
  icon: Globe
}];

const PartnersSection = () => {
  const navigate = useNavigate();
  const _scrollAnimation = useScrollAnimation({
    intensity: 0.025
  });

  return (
    <section id="partners-section" className="py-24 bg-gradient-accent">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 id="partners-heading" className="text-4xl font-bold text-center mb-16 text-foreground">
            Trusted <span className="bg-gradient-primary bg-clip-text text-transparent">Partners</span>
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {partnerData.map((partner, index) => {
              const Icon = partner.icon;
              return (
                <Card key={index} id={`partner-card-${index}`} className="p-8 bg-gradient-card border-0 shadow-elegant">
                  <CardHeader className="pb-4">
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-12 h-12 bg-gradient-primary rounded-2xl flex items-center justify-center">
                        <Icon className="h-6 w-6 text-white" />
                      </div>
                      <Badge id={`partner-type-${index}`} variant="secondary" className="bg-primary/10 text-primary">
                        {partner.type}
                      </Badge>
                    </div>
                    <CardTitle id={`partner-name-${index}`} className="text-xl text-foreground">{partner.name}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription id={`partner-description-${index}`} className="text-muted-foreground text-base leading-relaxed">
                      {partner.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              );
            })}
          </div>
          
          <div className="text-center mt-12">
            <Button 
              id="partners-cta-become-partner"
              variant="outline" 
              size="lg" 
              className="hover:bg-[#E9D5FF] hover:text-black transition-colors"
              onClick={() => navigate('/contact')}
            >
              Become a Partner
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
